import { useMemo } from 'react'
import { useNetwork, useWalletClient } from 'wagmi'
import { providers } from 'ethers'
import { getChainId } from 'config/constants/exchange'

export const useProviderOrSigner = (withSignerIfPossible = true, chainId: number) => {
  const { chain : chainInfo} = useNetwork()
  const { data: walletClient } = useWalletClient({ chainId : getChainId(chainInfo) })
  const { account, chain, transport } = walletClient
  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  }
  const provider = new providers.Web3Provider(transport, network)
  const signer = provider.getSigner(account.address)
  return useMemo(
    () => (withSignerIfPossible && account && account.address && signer ? signer : provider),
    [account, provider, signer, withSignerIfPossible , walletClient],
  )
}
